import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import GoogleSignInButton from "@/components/GoogleSignInButton";

export default function Register() {
  const { t, lang } = useLang();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", preferred_language: lang });
  const [submitting, setSubmitting] = useState(false);
  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const data = await register(form);
      toast.success(`Welcome, ${data.name} • +25 pts`);
      navigate("/account");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Registration failed");
    } finally { setSubmitting(false); }
  };
  return (
    <div data-testid="register-page" className="container-refined py-16 md:py-24 max-w-md">
      <p className="eyebrow">Sunbraider</p>
      <h1 className="mt-4 font-serif text-4xl text-forest-900">{t("auth.register_title")}</h1>
      <div className="mt-10 space-y-4">
        <GoogleSignInButton label={t("auth.google_signup")} testId="register-google-btn" />
        <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.28em] text-forest-700/60">
          <span className="flex-1 h-px bg-forest-900/10" />
          {t("auth.or_email")}
          <span className="flex-1 h-px bg-forest-900/10" />
        </div>
      </div>
      <form onSubmit={submit} className="mt-6 space-y-5" data-testid="register-form">
        <div>
          <label className="field-label">{t("auth.name")}</label>
          <input required data-testid="register-name" className="field-input" value={form.name} onChange={onChange("name")} />
        </div>
        <div>
          <label className="field-label">{t("auth.email")}</label>
          <input required type="email" data-testid="register-email" className="field-input" value={form.email} onChange={onChange("email")} />
        </div>
        <div>
          <label className="field-label">{t("auth.password")}</label>
          <input required type="password" minLength={8} data-testid="register-password" className="field-input" value={form.password} onChange={onChange("password")} />
        </div>
        <div>
          <label className="field-label">{t("auth.preferred_language")}</label>
          <select data-testid="register-language" className="field-input" value={form.preferred_language} onChange={onChange("preferred_language")}>
            <option value="en">English</option>
            <option value="nl">Nederlands</option>
            <option value="uk">Українська</option>
          </select>
        </div>
        <button disabled={submitting} className="btn-primary w-full justify-center" data-testid="register-submit">
          {submitting ? t("common.loading") : t("auth.submit_register")}
        </button>
        <p className="text-sm text-forest-700 text-center">
          {t("auth.have_account")} <Link to="/login" className="underline underline-offset-4 hover:text-forest-900" data-testid="register-login-link">{t("nav.login")}</Link>
        </p>
      </form>
    </div>
  );
}
